export default __webpack_public_path__ + "static/media/reverseStamped.78a638d9.svg";